import { MrAccordion } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-superett-accordion', MrAccordion );
